export function buildQueryString({
  searchOn,
  language,
  page,
  rowsPerPage,
  searchTerm,
}) {
  const searchString = searchTerm
    ? `&searchOn=${searchOn}&search=${searchTerm}&caseInsensitiveSearch=true`
    : "";
  return `language=${language}&skip=${page * rowsPerPage}&top=${rowsPerPage}&includeTotals=true&sortAsc=id${searchString}`;
}

export async function fetchAll(fetchFn, top = 9500) {
  let allResults = [];
  let skip = 0;

  while (true) {
    // call the provided fetch function with skip & top
    const data = await fetchFn({ skip, top });

    if (!data?.results?.length) break;

    allResults = allResults.concat(data.results);

    skip += top;
    if (skip >= data.total) break; // stop if we reached total
  }

  return {
    results: allResults,
    total: allResults.length,
  };
}

export async function fetchAllCursor(fetchFn, options = {}) {
  const { top = 5000, idField = "id", sortField = idField, language } = options;

  let results = [];
  let after;
  let total = Infinity;

  while (results.length < total) {
    const params = {
      top,
      sortAsc: sortField,
    };

    let query = `top=${top}&includeTotals=true&language=${language}&sortAsc=${sortField}`;

    if (after) {
      params.after = after;
      query = `after=${after}&${query}`;
    }

    const data = await fetchFn(query);

    if (!data?.results?.length) break;

    results.push(...data.results);

    if (data.total !== undefined) {
      total = data.total;
    }

    after = data.results[data.results.length - 1]?.[idField];

    if (!after) break;
  }

  return {
    results,
    total: results.length,
  };
}
